module.exports =
  MULTIPLE_INPUT_ITEM_DND_TYPE: 'multipleInputItem'

  dragSpec:
    beginDrag: (props) ->
      itemId: props.itemId
      index: props.index

    canDrag: (props) ->
      !props.readOnly

    isDragging: (props, monitor) ->
      props.itemId is monitor.getItem().itemId

  dropSpec:
    hover: (props, monitor, component) ->
      return if props.readOnly
      return unless component?.item

      draggingItem = monitor.getItem()
      dragIndex = draggingItem.index
      hoverIndex = props.index

      return if dragIndex is hoverIndex

      hoverBoundingRect = component.item.getBoundingClientRect()
      hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      clientOffset = monitor.getClientOffset()
      hoverClientY = clientOffset.y - hoverBoundingRect.top

      if dragIndex < hoverIndex and hoverClientY < hoverMiddleY
        return
      if dragIndex > hoverIndex and hoverClientY > hoverMiddleY
        return

      props.onMove dragIndex, hoverIndex
      draggingItem.index = hoverIndex

  dragCollect: (connect, monitor) ->
    connectDragSource: connect.dragSource()
    isDragging: monitor.isDragging()

  dropCollect: (connect, monitor) ->
    connectDropTarget: connect.dropTarget()
    isOver: monitor.isOver()
